// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F1sw","right":"styles_right__3euby"};